module.exports = __webpack_public_path__ + "static/img/cheer3.3f5946b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/cheer/cheer3.jpg
// module id = aS+t
// module chunks = 1